import { Component } from '@angular/core';
import { SgConfirmClickRef } from '@sg/ui-kit/click-confirm';

export interface SgYesNoClickConfirmPanelContext {
  title?: string;
  description?: string;
  textOk?: string;
  textCancel?: string;
  prompt?: {
    placeholder?: string;
    isDisabled?: (value: string) => boolean;
    onConfirm?: (value: string) => void;
  };
}

const DEFAULT_CONTEXT = {
  title: 'Please Confirm',
  textOk: 'Yes',
  textCancel: 'No',
};

@Component({
  selector: 'sg-click-confirm-panel',
  templateUrl: './yes-no-click-confirm-panel.component.html',
  styleUrls: ['./yes-no-click-confirm-panel.component.scss'],
  standalone: false,
})
export class SgYesNoClickConfirmPanel {
  data: SgYesNoClickConfirmPanelContext;
  promptValue: string = '';

  constructor(public confirmClickRef: SgConfirmClickRef<boolean, SgYesNoClickConfirmPanelContext>) {
    this.data = Object.assign({}, DEFAULT_CONTEXT, confirmClickRef.data || {});
  }

  close(confirmed: boolean): void {
    if (confirmed && this.data.prompt?.onConfirm) {
      this.data.prompt.onConfirm(this.promptValue);
    }
    this.confirmClickRef.close(confirmed);
  }
}
